export const roles = [
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 0 - Basic user with profile access only
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 1 - Basic user with profile access only
  [
    '/info-center',
    '/establishements',
    '/classes',
    '/users',
    '/subjects',
    '/remarques',
    '/exams',
    '/national-exams',
    '/admin-documents',
    '/qcm',
    '/exercices',
    '/video-gallery',
    '/quiz-leaderboard',
    '/ranking-board',
    '/grades',
    '/inventory',
    '/inventory-types',
    '/inventory-statistics',
    '/type-exams',
    '/type-remarques',
    '/payment-categories',
    '/payments',
    '/billing',
    '/payroll',
    '/payroll-categories',
    '/expenditures',
    '/profile',
    '/promotions',
    '/statistiques',
    '/email-management',
    '/users/infos',
    '/games',
    '/file-manager',
    '/zad',
    '/zad/categories',
    '/zad/product-types',
    '/zad/products',
    '/zad/labels',
    '/zad/catalogue',
    '/zad/promotions',
    '/zad/promo-codes',
    '/zad/stock',
    '/zad/stock/replenishment',
    '/zad/procurement',
    '/zad/suppliers',
    '/zad/purchases',
    '/zad/supplier-payments',
    '/zad/customers',
    '/zad/sales',
    '/zad/sales-history',
    '/zad/customer-payments',
    '/zad/customer-returns',
    '/zad/customer-refunds',
    '/zad/reports',
    '/zad/reports/accounting',
    '/zad/settings',
  ], // Role 2 - Admin (Full access + ZAD Library module)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/qcm', '/grades', '/users/details', '/payments', '/billing', '/payroll', '/games', '/file-manager'], // Role 3 - Teacher
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 4 - Student (Grades = Report card)
  ['/info-center', '/kids', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 5 - Parent (Grades = Report card)
  ['/info-center', '/payments', '/billing', '/profile', '/payment-categories', '/users', '/expenditures', '/admin-documents', '/games', '/file-manager', '/zad/reports/accounting', '/zad/sales-history'], // Role 6 - Finance Manager: school finance + ZAD accounting + sales history reports
  ['/info-center', '/inventory', '/inventory-types', '/profile', '/billing', '/games', '/file-manager'], // Role 7 - Stock Manager
  ['/info-center', '/profile', '/payments', '/billing'], // Role 8 - Limited Student (Profile + Payments only)
  ['/info-center', '/payroll', '/payroll-categories', '/profile', '/billing', '/expenditures', '/users'], // Role 9 - Accountant / Comptable (Payroll-only)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/subjects', '/users/details', '/expenditures', '/payments', '/billing', '/games', '/file-manager'], // Role 10 - Secretary / Secrétaire (Teacher + Subjects management)
  ['/zad', '/profile', '/zad/categories', '/zad/product-types', '/zad/products', '/zad/labels', '/zad/catalogue', '/zad/promotions', '/zad/promo-codes', '/zad/stock', '/zad/stock/replenishment', '/zad/procurement', '/zad/suppliers', '/zad/purchases', '/zad/supplier-payments', '/zad/customers', '/zad/sales', '/zad/sales-history', '/zad/customer-payments', '/zad/customer-returns', '/zad/customer-refunds', '/zad/reports'], // Role 11 - ZAD Library (frontend shell only; no school modules)
]

export const ZAD_LIBRARY_ROLE = '11'
export const ZAD_LIBRARY_ROLE_INDEX = 11
export const UNKNOWN_ROLE_REDIRECT = '/profile'

/** Registered ZAD routes. Future: /zad/payments */
export const ZAD_REGISTERED_PATHS = ['/zad', '/zad/categories', '/zad/product-types', '/zad/products', '/zad/labels', '/zad/catalogue', '/zad/promotions', '/zad/promo-codes', '/zad/stock', '/zad/stock/replenishment', '/zad/procurement', '/zad/suppliers', '/zad/purchases', '/zad/supplier-payments', '/zad/customers', '/zad/sales', '/zad/sales-history', '/zad/customer-payments', '/zad/customer-returns', '/zad/customer-refunds', '/zad/reports', '/zad/reports/accounting', '/zad/settings'] as const

export const ZAD_FINANCIAL_ROLES = [2, 6] as const
export const ZAD_ACCOUNTING_REPORT_PATH = '/zad/reports/accounting'

export function hasZadFinancialAccess(role: string | number | undefined | null): boolean {
  const index = resolveRoleIndex(role)
  return index === 2 || index === 6
}

export function isZadAccountingReportPath(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)
  return path === ZAD_ACCOUNTING_REPORT_PATH || path.startsWith(`${ZAD_ACCOUNTING_REPORT_PATH}/`)
}

export const resolveRoleIndex = (role: string | number | undefined | null): number | null => {
  if (role === undefined || role === null) {
    return null
  }

  // 1) Direct numeric roles (e.g. '2', 3, 9 ...)
  const numeric = Number(role)
  if (!Number.isNaN(numeric)) {
    return numeric
  }

  const roleStr = `${role}`.toLowerCase().trim()

  // 2) Named roles coming from backend (e.g. 'ROLE_ACCOUNTANT', 'ACCOUNTANT', etc.)
  const map: Record<string, number> = {
    // Existing numeric mappings can be added here if backend ever sends names
    role_admin: 2,
    admin: 2,
    administrator: 2,
    role_teacher: 3,
    teacher: 3,
    role_student: 4,
    student: 4,
    role_parent: 5,
    parent: 5,
    role_finance: 6,
    finance: 6,
    finance_manager: 6,
    role_accountant: 9,
    accountant: 9,
    comptable: 9,
    role_secretary: 10,
    secretary: 10,
    secretaire: 10,
    role_secretaire: 10,
    zad: 11,
    zad_library: 11,
    role_zad_library: 11,
  }

  if (map[roleStr] !== undefined) {
    return map[roleStr]
  }

  // 3) Try to extract any digits if the role is like 'ROLE_9'
  const match = roleStr.match(/\d+/)
  if (match) {
    const extracted = Number(match[0])
    return Number.isNaN(extracted) ? null : extracted
  }

  return null
}

export function normalizeRoutePath(pathname: string): string {
  if (!pathname) return '/'
  return pathname.length > 1 && pathname.endsWith('/') ? pathname.replace(/\/+$/, '') : pathname
}

/** Configured path prefixes for a role, or null when the role is unknown / unconfigured. */
export function getRolePathPrefixes(role: string | number | undefined | null): string[] | null {
  const roleIndex = resolveRoleIndex(role)
  if (roleIndex === null) return null
  const configured = roles[roleIndex]
  if (!configured?.length) return null
  return configured
}

/**
 * Deny-by-default path check used by PrivateRoutes.
 * Unknown, unresolved, or unconfigured roles never authorize a private path.
 */
export function isPathAuthorizedForRole(
  role: string | number | undefined | null,
  pathname: string
): boolean {
  const userRoles = getRolePathPrefixes(role)
  if (!userRoles) return false

  const path = normalizeRoutePath(pathname)
  if (isZadAccountingReportPath(path)) {
    return hasZadFinancialAccess(role)
  }

  let authorized = userRoles.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))

  if (
    !authorized &&
    (path === '/national-exams' ||
      path.startsWith('/national-exams/') ||
      path.startsWith('/qcm/') ||
      path === '/qcm')
  ) {
    authorized = userRoles.includes('/national-exams') || userRoles.includes('/exams')
  }

  return authorized
}

export function getUnauthorizedRedirect(role: string | number | undefined | null): string {
  const userRoles = getRolePathPrefixes(role)
  if (!userRoles?.[0]) return UNKNOWN_ROLE_REDIRECT
  return userRoles[0]
}
